import { toast } from 'react-toastify'
import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import ContactAnAdviser from './ContactAnAdviser'
import * as styles from './_ContactAnAdviser.scss'
import history from '../../core/history'
import {
  validateContact,
  setName,
  setEmail,
  setContact,
  setComment,
  submitAdviserContact,
  setResponseStatus,
  fetchTotalEmailsSent,
  submitSentEmail,
  clearContactDetails
} from './ContactAnAdviserContainerActions'
import {fetchEmailRateLimiter} from '../AdministrationPortal/Configurations/ConfigureRateLimiter/ConfigureRateLimiterActions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types';

class ContactAnAdviserContainer extends React.Component {

  static propTypes = {
    adviserId: PropTypes.number.isRequired,
    adviserContactContainer: PropTypes.object.isRequired,
    validateContact: PropTypes.func.isRequired,
    setName: PropTypes.func.isRequired,
    setContact: PropTypes.func.isRequired,
    setEmail: PropTypes.func.isRequired,
    setComment: PropTypes.func.isRequired,
    submitAdviserContact: PropTypes.func.isRequired,
    submittedStatus: PropTypes.string.isRequired,
    searchCriteria: PropTypes.object,
    setResponseStatus: PropTypes.func.isRequired,
    adviserName: PropTypes.string.isRequired,
    fetchEmailRateLimiter: PropTypes.func.isRequired,
    fetchTotalEmailsSent: PropTypes.func.isRequired,
    totalEmailsSent: PropTypes.number.isRequired,
    emailRateLimiter: PropTypes.number.isRequired,
    submitSentEmail: PropTypes.func.isRequired,
    validationstate: PropTypes.shape({
      formIsValid: PropTypes.bool,
      NameContainer: PropTypes.shape({
        isInvalid: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
        message: PropTypes.string,
        valid: PropTypes.bool
      }),
      NumberContainer: PropTypes.object,
      EmailContainer: PropTypes.object,
      CommentContainer: PropTypes.object
    }).isRequired
  }

  constructor (props) {
    super(props)

    this.handleSubmit = this.handleSubmit.bind(this)
    this.navigationBack = this.navigationBack.bind(this)
  }

  contactDetailsChanged (oldContactDetails, newContactDetails) {
    const { enteredName, enteredNumber, enteredComment, enteredEmail } = oldContactDetails

    return enteredName !== newContactDetails.enteredName ||
      enteredNumber !== newContactDetails.enteredNumber ||
      enteredEmail !== newContactDetails.enteredEmail ||
      enteredComment !== newContactDetails.enteredComment
  }

  shouldComponentUpdate (nextProps) {
    const { adviserId, adviserContactContainer, submittedStatus, emailRateLimiter } = this.props
    var shouldUpdate = adviserId !== nextProps.adviserId ||
      submittedStatus !== nextProps.submittedStatus ||
      emailRateLimiter !== nextProps.emailRateLimiter ||
      this.contactDetailsChanged(adviserContactContainer, nextProps.adviserContactContainer)
    return shouldUpdate
  }

  componentDidMount () {
    this.props.setResponseStatus('PENDING')
    this.fetchRateLimiterInfo()
  }

  clearContactDetails () {
    this.props.adviserContactContainer.enteredName = ''
    this.props.adviserContactContainer.enteredNumber = ''
    this.props.adviserContactContainer.enteredEmail = ''
    this.props.adviserContactContainer.enteredComment = ''
    this.props.adviserContactContainer.isInvalid.formIsValid = false
    this.props.adviserContactContainer.isInvalid.NameContainer = {
      isInvalid: false,
      message: null,
      valid: false
    }
    this.props.adviserContactContainer.isInvalid.NumberContainer = {
      isInvalid: false,
      message: null,
      valid: false
    }
    this.props.adviserContactContainer.isInvalid.EmailContainer = {
      isInvalid: false,
      message: null,
      valid: false
    }
  }

  async fetchRateLimiterInfo () {
    await this.props.fetchEmailRateLimiter()
  }

  async handleSubmit () {
    this.props.setResponseStatus('SUBMITTING')
    this.props.validateContact('All')
    if (this.props.adviserContactContainer.isInvalid.formIsValid) {
      await this.props.fetchTotalEmailsSent({
        fromEmailAddress: this.props.adviserContactContainer.enteredEmail.toLowerCase()
      })

      const { totalEmailsSent } = this.props.adviserContactContainer
      const { emailRateLimiter } = this.props

      if (totalEmailsSent >= emailRateLimiter) {
        this.props.clearContactDetails()
        toast.warn('You have reached your daily email limit', {
          autoClose: 10000
        })
        this.props.setResponseStatus('LIMIT_EXCEEDED')
        return
      }

      var adviserContact = {
        adviserId: this.props.adviserId,
        contactName: this.props.adviserContactContainer.enteredName,
        contactNumber: this.props.adviserContactContainer.enteredNumber,
        contactEmailAddress: this.props.adviserContactContainer.enteredEmail,
        contactComment: this.props.adviserContactContainer.enteredComment,
        searchCriteria: this.props.searchCriteria
      }

      // First, send the email and wait for it to complete
      await this.props.submitAdviserContact(adviserContact)

       toast.success('Contact request submitted', {
          autoClose: 10000
        })

      // Only after the above completes, submit the sent email details
      const sentEmail = {
        fromEmailAddress: this.props.adviserContactContainer.enteredEmail.toLowerCase(),
        fullName: this.props.adviserContactContainer.enteredName,
        adviserId: this.props.adviserId,
        emailBody: this.props.adviserContactContainer.enteredComment
      }

      await this.props.submitSentEmail(sentEmail)
      this.props.setResponseStatus('SUBMITTED')
    }
  }

  render () {
    const { adviserContactContainer, validateContact, setName, setContact, setEmail, setComment, submittedStatus, emailRateLimiter } = this.props

    if (!emailRateLimiter) return null

    return (
      <ContactAnAdviser
        validationstate={adviserContactContainer.isInvalid}
        validateContact={validateContact}
        setName={setName}
        setContact={setContact}
        setEmail={setEmail}
        setComment={setComment}
        handleSubmit={this.handleSubmit}
        submittedStatus={submittedStatus}
        navigationBack={this.navigationBack}
        nameAndSurname={adviserContactContainer.enteredName}
        contactNumber={adviserContactContainer.enteredNumber}
        emailAddress={adviserContactContainer.enteredEmail}
        comment={adviserContactContainer.enteredComment}
      />
    )
  }

  navigationBack () {
    history.push(`/adviser/${this.props.adviserName}/${this.props.adviserId}/profile/view`)
  }
}

const mapStateToProps = (state) => {
  return {
    adviserContactContainer: state.adviserContactContainer,
    submittedStatus: state.adviserContactContainer.submittedStatus,
    searchCriteria: state.findAnIfa.searchCriteria,
    totalEmailsSent: state.adviserContactContainer.totalEmailsSent,
    emailRateLimiter: parseInt(state.configureRateLimiterContainer.emailRateLimiter),
    validationstate: state.adviserContactContainer.isInvalid
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    validateContact: validateContact,
    setName: setName,
    setContact: setContact,
    setEmail: setEmail,
    setComment: setComment,
    submitAdviserContact: submitAdviserContact,
    setResponseStatus: setResponseStatus,
    fetchEmailRateLimiter: fetchEmailRateLimiter,
    fetchTotalEmailsSent: fetchTotalEmailsSent,
    submitSentEmail: submitSentEmail,
    clearContactDetails: clearContactDetails
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (ContactAnAdviserContainer))
